import React, { useEffect, useState } from "react";
import SelectCrypto from "./SelectCrypto";
import { Grid } from "@mui/material";
import { socketWithdrawals } from "../../Sockets/WithdrawalsSocket.js";
import { SocketMessages } from "../../enums/SocketMessages.js";
import RequestResume from "./RequestResume.js";
import { useParams } from "react-router";

const MainWithdrawals = ({ token, id }) => {
	const params = useParams();
	const { crypto, net } = params;
	const [step, setStep] = useState(1);
	const [cryptoCurrency, setCryptoCurrency] = useState(crypto ?? null);
	const [network, setNetwork] = useState(net ?? null);
	const [address, setAddress] = useState(null);
	const [memo, setMemo] = useState(null);
	const [amount, setAmount] = useState(0);
	const [withdrawal, setWithdrawal] = useState(null);
	const [agreement, setAgreement] = useState(false);
	const [isConnected, setIsConnected] = useState(false);

	useEffect(() => {
		const onConnect = () => {
			setIsConnected(true);
		};

		const onDisconnect = () => {
			setIsConnected(false);
		};

		const onRequestWithdrawal = (data) => {
			if (data.agent.toString() === id.toString()) {
				setWithdrawal(data);
				setStep(2);
			}
		};

		socketWithdrawals.on(SocketMessages.CONNECT, onConnect);
		socketWithdrawals.on(SocketMessages.DISCONNECT, onDisconnect);
		socketWithdrawals.on(SocketMessages.WITHDRAWALS, onRequestWithdrawal);

		// Connect the socket when the component mounts
		socketWithdrawals.connect();

		// Clean up the event listeners and disconnect when the component unmounts
		return () => {
			socketWithdrawals.off(SocketMessages.CONNECT, onConnect);
			socketWithdrawals.off(SocketMessages.DISCONNECT, onDisconnect);
			socketWithdrawals.disconnect(); // Disconnect to prevent memory leaks and unnecessary connections
		};
	}, []);

	if (step === 1) {
		return (
			<Grid container sx={{ justifyContent: "center", alignContent: "center" }}>
				<SelectCrypto
					title={"Account Withdrawal"}
					setCryptoCurrency={setCryptoCurrency}
					cryptoCurrency={cryptoCurrency}
					network={network}
					setNetwork={setNetwork}
					agreement={agreement}
					setAgreement={setAgreement}
					address={address}
					setAddress={setAddress}
					setStep={setStep}
					step={step}
					token={token}
					amount={amount}
					setAmount={setAmount}
					id={id}
					setWithdrawal={setWithdrawal}
					setMemo={setMemo}
					memo={memo}
				/>
			</Grid>
		);
	}

	if (step === 2) {
		return (
			<Grid container sx={{ justifyContent: "center", alignContent: "center" }}>
				<RequestResume cryptoCurrency={cryptoCurrency} network={network} title={`Account Withdrawal`} withdrawal={withdrawal} />
			</Grid>
		);
	}
};

export default MainWithdrawals;
